/* src/app/private/components/admission/create-student-profile/create-student-profile.component.scss */
/*# sourceMappingURL=create-student-profile.component.css.map */
